export default "__VITE_ASSET__f3da12a4__"